/* eslint-disable @next/next/no-head-element */
/* eslint-disable @next/next/no-page-custom-font */
import { ReactNode } from 'react';
import { publicSans } from '@/components/kd/fonts';
import { SessionProvider } from 'next-auth/react';

import HeaderKD from '../HeaderKD';
import SkipLink, { MAIN_CONTENT_ID } from '@/components/common/skip-link';
import FooterKD from '../FooterKD';

import '../../../app/globals.css';
import './DefaultLayoutKD.css';

interface LayoutProps {
  children: ReactNode;
}

const DefaultLayoutKD = async ({ children }: LayoutProps) => {
  return (
    <html lang="en" className={publicSans.variable}>
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </head>
      <body className="body-kd">
        <SessionProvider session={null}>
          <link rel="shortcut icon" href="/kd/favicon.ico" />
          <div className="h-full flex flex-col justify-between">
            <div>
              <SkipLink />
              <HeaderKD />
              <main id={MAIN_CONTENT_ID} tabIndex={-1} className="outline-none">
                {children}
              </main>
            </div>
            <div>
              <FooterKD isAuthorized={false} />
            </div>
          </div>
        </SessionProvider>
      </body>
    </html>
  );
};

export default DefaultLayoutKD;
